export default "__VITE_ASSET__36697735__"